import React from 'react';
import { Form } from 'react-final-form';

import validateYupSchema from 'common/utils/validateYupSchema';

import {
  AddEditVenueGroup,
  FormValues as AddEditVenueGroupFormValues,
  Props as AddEditVenueGroupProps,
} from './AddEditVenueGroup';
import { createEditVenueGroupSchema } from './schema';
import { WoltModal } from './styles';

export type FormValues = AddEditVenueGroupFormValues;

type Props = Pick<AddEditVenueGroupProps, 'onClose' | 'venueGroup'> & {
  isOpen: boolean;
  onSubmit: (values: FormValues) => void;
};
const venueGroupValidationSchema = createEditVenueGroupSchema();

export const EditVenueGroupModal = ({ venueGroup, onSubmit, isOpen, onClose }: Props) => {
  const initialValues = {
    venueGroupName: venueGroup?.name ?? '',
    description: venueGroup?.description ?? '',
  };

  return (
    <WoltModal isOpen={isOpen} onRequestClose={onClose}>
      <Form<FormValues>
        validate={validateYupSchema(venueGroupValidationSchema)}
        initialValues={initialValues}
        onSubmit={onSubmit}
        render={({ handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <AddEditVenueGroup venueGroup={venueGroup} onClose={onClose} />
            </form>
          );
        }}
      />
    </WoltModal>
  );
};
